module.exports = require('./lib/emoji');


/*****************
 ** WEBPACK FOOTER
 ** ./~/emoji/index.js
 ** module id = 480
 ** module chunks = 0
 **/